module.exports = __webpack_public_path__ + "e9efcfbefa5d86d73cf2e8320dd3ed52.svg";